import {Presentation, PresentationState} from "@nolimitcity/slot-game/bin/core/gamecontroller/presentations/Presentation";
import {WGParsedGameData} from "../../../server/data/WGParsedGameData";
import {WGEngineManager} from "../../../engine/WGEngineManager";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {WarriorGraveyardGameModuleConfig} from "../../../WarriorGraveyardGameModuleConfig";
import {SoundManager} from "../../../resource/sound/SoundManager";
import {WGSoundConfig} from "../../../WGSoundConfig";

export class StickyWild extends Presentation {

    private _afterWildReels: boolean[] = [];
    private _beforeWildReels: boolean[] = [];
    private _lockingWildAnimationOnReels: TimelineSprite[] = [];

    public checkForActivation(data: WGParsedGameData): boolean {
        return data.superFreespin && this.checkForChangeInLockedReelArray(data.lockedWildReelsBefore, data.lockedWildReelsAfter);
    }

    /**
     * function to check is new wild is there to stick or not
     * @param before
     * @param after
     */
    private checkForChangeInLockedReelArray(before: boolean[], after: boolean[]): boolean {
        if ((after.filter(value => value === true).length) !== (before.filter(value => value === true).length)) {
            return true;
        }
        return false;
    }


    public setParsedGamedData(data: WGParsedGameData): void {
        this._beforeWildReels = data.lockedWildReelsBefore;
        this._afterWildReels = data.lockedWildReelsAfter;
    }

    /**
     * hide multiplier and show cage, chain from here
     */
    public getPresentation(): void {
        for (let i = 1; i < 5; i++) {
            if (this._afterWildReels[i] !== this._beforeWildReels[i]) {
                let reel = WGEngineManager.getReel(i);
                WarriorGraveyardGameModuleConfig.stickWildView._lockingCageContainer[i - 1].visible = true;
                this.pTimeline.add(() => {
                    SoundManager.playSoundEffect(WGSoundConfig.instance.WILD_CHAIN);
                });
                this.pTimeline.add(() => {
                    WarriorGraveyardGameModuleConfig.anticipationAnimation._wildLandinAnimation[i - 1].visible = false;
                });
                this.pTimeline.add([
                    WarriorGraveyardGameModuleConfig.stickWildView.playShineAnimOnWIld(i),
                    WarriorGraveyardGameModuleConfig.stickWildView._lockingWildAnimationOnReels[i - 1].getAnimationAutoShowHide(true, false)]);
            }
        }
        this.pTimeline.add(() => {
            this.PresentationState.set(PresentationState.END);
        }, this.pTimeline.duration() + 1);
    }

    /**
     * stop presentation
     */
    public stopPresentation(): void {
        this.PresentationState.set(PresentationState.INACTIVE);
    }

}